import React, { useState, useEffect, useRef } from "react";
import {
  getProvidersName,
  getGenderSpecialties,
  getAddress,
  getFormatedPhoneNumber,
} from "../../utils/find-providers";

const ProviderItem = ({
  components,
  providerData,
  onProviderSelect,
  addFavoriteIcon,
  favoriteProviders = [],
  onMouseEnter,
  onMouseLeave,
  active,
  selected,
}) => {
  const [isFavorite, setFavorite] = useState(
    !!(favoriteProviders || []).find(
      (provider) => providerData.id === provider.data.id
    )
  );

  const { profile, practices, specialties } = providerData;
  const el = useRef();

  useEffect(() => {
    if (active && el.current) {
      el.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [active]);

  return (
    <div
      ref={el}
      className={`provider-item-web-sdk ${active || selected ? "active" : ""}`}
      onMouseEnter={() => onMouseEnter(providerData.id)}
      onMouseLeave={() => onMouseLeave()}
    >
      {profile.imageUrl ? (
        <components.Image
          size={50}
          url={profile.imageUrl}
          components={components}
        />
      ) : null}
      <div className='provider-info-web-sdk'>
        <div className='name-distance-wrapper-web-sdk'>
          <components.Text
            label={getProvidersName(profile)}
            onClick={onProviderSelect}
          />
          <components.Label
            text={`${practices[0].distance.toFixed(2)} mi`}
            params='provider-distance-web-sdk'
          />
        </div>
        <components.Label
          text={getGenderSpecialties(specialties, profile.gender)}
        />
        <components.Label
          text={getAddress(practices[0].visitAddress)}
          params='provider-address-web-sdk'
        />
        <div className='provider-phone-like-wrapper-web-sdk'>
          <div>
            {practices[0].phones[0].number ? (
              <>
                <components.Label
                  text={getFormatedPhoneNumber(practices[0])}
                  params='provider-detail-phone-web-sdk'
                />
                <components.PhoneLink
                  label='Call'
                  link={practices[0].phones[0].number}
                />
              </>
            ) : null}
          </div>
          {addFavoriteIcon(isFavorite, providerData, setFavorite)}
        </div>
      </div>
    </div>
  );
};

export default ProviderItem;
